import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokSpecialPackageInfluencers.graphql';
import { Query, QuerytiktokSpecialPackageInfluencersArgs } from '../../__generated__/globalTypes';

export const useTiktokSpecialPackageInfluencersQuery = (
  options?: QueryHookOptions<Query, QuerytiktokSpecialPackageInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokSpecialPackageInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokSpecialPackageInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokSpecialPackageInfluencersArgs>
): QueryResult<Query, QuerytiktokSpecialPackageInfluencersArgs> & {
  getTiktokSpecialPackageInfluencers: LazyQueryExecFunction<Query, QuerytiktokSpecialPackageInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokSpecialPackageInfluencers, result] = useLazyQuery<Query, QuerytiktokSpecialPackageInfluencersArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getTiktokSpecialPackageInfluencers, ...result };
};

export const useTiktokSpecialPackageInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokSpecialPackageInfluencers = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokSpecialPackageInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokSpecialPackageInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokSpecialPackageInfluencers };
};
// Suspense Query Hooks
export const useTiktokSpecialPackageInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokSpecialPackageInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokSpecialPackageInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
